<template>
    <div class="tree-node-wrapper">
        <div class="current-label" :class="{ 'tree-node-selected': data.isSelected }">
            <div class="label" :style="{ 'font-size': fontSize, 'padding-left': paddingLeft }" @click="labelClick">
                <div class="expand-arrow" :style="{ visibility: showArrow }" :class="{ 'expand-down': data.expand }"></div>
                <div class="node-label" v-if="!data.editing" :title="data.label">{{ data.label }}</div>
                <span v-if="data.editing">
                    <input v-model="editVal" class="edit-input" @keypress="keyPressHandler" @blur="blurHandle" ref="labelInput" />
                </span>
                <em class="small-label">({{ data.smallLabel }})</em>
            </div>
            <div class="operator" v-if="editable">
                <EditPanel :editFlags="editFlags" :isFirst="data.isFirstNode" @oprClick="operateClick" @transferEnd="transferEnd" />
            </div>
        </div>
        <div class="child-Panel" v-show="data.expand">
            <TreeNode
                v-for="child in childDatas"
                :key="child.id"
                :data="child"
                :editable="editable"
                @selectNode="selectChildNode"
                @expandNode="expandChildNode"
                @operatorClick="childOprClick"
                @transferEnd="childTransferEnd"
            ></TreeNode>
        </div>
    </div>
</template>

<script>
import EditPanel from "./EditPanel";

const FIRST_LEVEL = 1;
const DEFAULT_OPTIONS = ["add", "edit", "delete", "move"];

export default {
    name: "TreeNode",
    props: ["data", "editable"],
    components: {
        EditPanel
    },
    data() {
        return {
            editVal: this.data.label
        };
    },
    computed: {
        fontSize() {
            return this.data.level === FIRST_LEVEL ? "14px" : "12px";
        },
        paddingLeft() {
            return (this.data.level - 1) * 14 + "px";
        },
        showArrow() {
            return this.hasChildren() ? "visible" : "hidden";
        },
        editFlags() {
            let flags = this.data.editFlags || [...DEFAULT_OPTIONS];

            if (this.data.isLeaf) {
                deleteFlag(flags, "add");
            }

            return flags;
        },
        childDatas() {
            return this.data.children || [];
        }
    },
    // mounted() {
    //     window.document.addEventListener("click", this.windowClick);
    // },
    // destroyed() {
    //     window.document.removeEventListener("click", this.windowClick);
    // },
    methods: {
        labelClick() {
            this.$emit("selectNode", {
                path: "" + this.data.id
            });

            this.$emit("expandNode", {
                path: "" + this.data.id
            });
        },
        hasChildren() {
            return this.data.children && this.data.children.length;
        },
        operateClick(opr) {
            if (opr == "edit") {
                this.editVal = this.data.label;
                setTimeout(() => {
                    this.$refs.labelInput && this.$refs.labelInput.focus();
                }, 50);
            }
            this.$emit("operatorClick", {
                path: this.data.id,
                opr: opr,
                label: this.data.label,
                level: this.data.level,
                isLikeDisplay: this.data.isLikeDisplay,
                isConsidered: this.data.isConsidered,
            });
        },
        transferEnd(newIdx) {
            this.$emit("transferEnd", {
                path: this.data.id,
                newIdx
            });
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;

            isEnterKey && this.emitEditEvent();
        },
        emitEditEvent() {
            const newLabel = this.zhiji.strTrim(this.editVal);
            const isChanged = newLabel != this.data.label;

            newLabel &&
                this.$emit("operatorClick", {
                    path: this.data.id,
                    opr: "edit",
                    newLabel: newLabel,
                    isChanged
                });
        },
        windowClick(event) {
            // current-label 去判断有点问题
            if (this.data.editing && this.zhiji.isClickOuter(event, "current-label")) {
                this.emitEditEvent();
            }
        },
        blurHandle() {
            this.emitEditEvent();
        },

        // 子节点事件透传
        selectChildNode(data) {
            this.$emit("selectNode", {
                path: this.data.id + "/" + data.path
            });
        },
        expandChildNode(data) {
            this.$emit("expandNode", {
                path: this.data.id + "/" + data.path
            });
        },
        childOprClick(data) {
            data.path = this.data.id + "/" + data.path;

            this.$emit("operatorClick", data);
        },
        childTransferEnd(data) {
            data.path = this.data.id + "/" + data.path;

            this.$emit("transferEnd", data);
        }
    }
};

function deleteFlag(flags, flagType) {
    let addIdx = flags.indexOf(flagType);
    if (addIdx != -1) {
        flags.splice(addIdx, 1);
    }
}
</script>

<style lang="less" scoped>
.tree-node-wrapper {
    position: relative;
    cursor: pointer;

    .expand-arrow {
        display: inline-block;
        width: 6px;
        height: 10px;
        margin: 0 4px 0 18px;
        content: "";
        background: url("@{zhijiStaticImagePath}class-spr.png");
        background-position: -130px 0;
    }

    .expand-down {
        position: relative;
        top: 2px;
        transform: rotate(90deg);
        transition: transform 0.2s ease-in-out;
    }

    .edit-input {
        padding: 5px 0;
        width: 120px;
        border: 1px solid #d8e4f0;
        box-sizing: border-box;
        border-radius: 4px;

        &:focus {
            border: 1px solid #2088f3;
        }
    }

    .small-label {
        color: #9b9ba3;
        font-size: 12px;
    }

    .operator {
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px 11px 0 11px;
        transform: translateX(110%);
        font-size: 0;
        white-space: nowrap;
        vertical-align: middle;
        background: #fbfbff;
        box-sizing: border-box;
        transition: transform 0.3s ease-in-out;
        z-index: 1;
    }

    &.moving {
        background: #fafbfd !important;
        & > .current-label {
            box-shadow: 0 0 8px rgba(46, 98, 151, 0.2) !important;

            .label {
                background: transparent !important;
            }

            .operator {
                transform: translateX(0) !important;
                transition: none;
                padding: 0 11px !important;
                background: linear-gradient(to left, #fbfdff 97%, #ebeff5 97.5%, #eef2f7 98%, #f7f8f9 98.5%, #f7f8fa 99%, #f4f7fa) !important;
            }
        }
    }

    .node-label {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        height: 18px;
        line-height: 16px;
        vertical-align: middle;
        max-width: calc(100% - 94px);
        text-overflow: ellipsis;
    }

    .current-label {
        width: 100%;
        line-height: 48px;

        .label {
            width: 100%;
        }

        &:hover {
            .label {
                background: rgba(217, 235, 246, 0.7);
                color: #2ec2ff;

                .small-label {
                    color: #2ec2ff;
                }
            }

            .operator {
                transform: translateX(0);
                background: linear-gradient(to left, #fbfdff 96%, #dcebf5 96.5%, #dae9f4 98%, #e1eff7 98.5%, #deecf6 99%, #e4f1f9);
            }
        }
    }

    .tree-node-selected {
        .label {
            color: #2ec2ff;
            background: rgba(217, 235, 246, 1);
            .small-label {
                color: #2ec2ff;
            }
        }
    }

    .child-Panel {
        padding-top: 1px;
        margin-top: -1px;
        position: relative;

        .tree-node-selected {
            background: #e4f1f9;
        }
    }
}
</style>
